module.exports = __webpack_public_path__ + "img/Bear05.355871c9.jpg";